export function isExpiryDate(date) {
  let diff = new Date().getTime() - new Date(date).getTime()
  return diff > 0
}